import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const LogoutIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M12 18.25a.75.75 0 000 1.5h6A1.75 1.75 0 0019.75 18V6A1.75 1.75 0 0018 4.25h-6a.75.75 0 000 1.5h6a.25.25 0 01.25.25v12a.25.25 0 01-.25.25h-6z"
        fill={tintColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.503 14.365c.69 0 1.25-.56 1.25-1.25v-2.24c0-.69-.56-1.25-1.25-1.25H9.89a26.723 26.723 0 00-.02-.22l-.054-.556a1.227 1.227 0 00-1.751-.988 15.059 15.059 0 00-4.368 3.163l-.099.104a1.253 1.253 0 000 1.734l.1.103a15.06 15.06 0 004.367 3.164 1.227 1.227 0 001.751-.988l.054-.556.02-.22h4.613zm-5.308-1.5a.75.75 0 00-.748.704c-.019.29-.042.581-.07.871l-.016.162a13.562 13.562 0 01-3.516-2.607 13.558 13.558 0 013.516-2.607l.016.162c.028.29.051.58.07.871a.75.75 0 00.748.704h5.058v1.74H9.195z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default LogoutIcon;
